import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { MatTabsModule } from '@angular/material/tabs';
import { ColorPickerModule } from 'ngx-color-picker';

@Component({
  selector: 'app-icon-color-picker',
  standalone: true,
  templateUrl: './icon-color-picker.component.html',
  styleUrls: ['./icon-color-picker.component.scss'],
  imports: [
    CommonModule,
    MatMenuModule,
    MatTabsModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule, 
    ColorPickerModule,
    MatFormFieldModule,
    ReactiveFormsModule,  
  ]
})
export class IconColorPickerComponent implements OnInit, OnChanges {
  @ViewChild(MatMenuTrigger) trigger!: MatMenuTrigger;

  @Input() readOnlyMode: boolean = false;
  @Input() customStyle: boolean = false;
  // @Input() disabled: boolean = false;
  @Input() icons: string[] = [];
  @Input() colors: string[] = [];
  @Input() selectedColor: string = '#fffff';
  @Input() shiftType: 'FULL_DAY_DUTY' | 'FIRST_HALF_DAY_DUTY' | 'SECOND_HALF_DAY_DUTY' | null = null;
  private _iconType: string | null = null;
  private _iconColour: string | null = null;
  private _selectedIcon: string | null = null;
  private _disabled:boolean = false
  @Input() set iconType(value: string | null) {
    this._iconType = value;
    if (this.customIconForm) {
      this.customIconForm.patchValue({ iconType: value });
    }
  }
  get iconType(): string | null {
    return this._iconType;
  }
  @Input() set disabledField(value: boolean) {
    this._disabled = value;
  }
  get disabledField(): boolean {
    return this._disabled;
  }

  @Input() set iconColour(value: string | null) {
    this._iconColour = value;
    if (this.customIconForm) {
      this.customIconForm.patchValue({ customTextColor: value });
    }
  }
  get iconColour(): string | null {
    return this._iconColour;
  }

  @Input() set selectedIcon(value: string | null) {
    this._selectedIcon = value;
    // if (this.customIconForm && this.iconType === 'text') {
    //   this.customIconForm.patchValue({ customText: value });
    // }
  }
  get selectedIcon(): string | null {
    return this._selectedIcon;
  }

  @Output() selectionChange = new EventEmitter<{
    icon: string | null;        // actual icon name/SVG
    color: string | null;       // color for SVG icon
    iconType: 'text' | 'svg' | null; // type of icon
    iconColour: string | null;  // text color if type is "text"
  }>();

  tabIndex = 0;
  selectedCustomIcon: { text: string; color: string; };
  customIconForm!: FormGroup;

  constructor(private fb: FormBuilder) {}
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['iconType']){
      this.customIconForm?.patchValue({ iconType: this.iconType });
      if(this.iconType === 'text'){
        this.customIconForm?.patchValue({ customText: this.selectedIcon });
      }
    }
    if (changes['selectedIcon'] && this.iconType === 'text'){
      this.customIconForm?.patchValue({ customText: this.selectedIcon });
    }
    this.customIconForm?.get('customText')?.valueChanges.subscribe(value => {
      this.emitSelection()
    });
  }

  ngOnInit(): void {
    this.addSelectedColorIfMissing();
    this.customIconForm = this.fb.group({
      customText: [ this.iconType == 'text' ? this.selectedIcon: '', [Validators.maxLength(3)]],
      customTextColor: [ this.iconColour ],
      iconType: [ this.iconType ?? 'svg' ]
    });
  }

  private emitSelection() {
    const customText = this.customIconForm.get('customText')?.value || null;
    const customTextColor = this.customIconForm.get('customTextColor')?.value || null;

    const isTextIcon =  !!customText; 
    const iconType: 'text' | 'svg' = isTextIcon ? 'text' : 'svg';

    this.selectionChange.emit({
      icon: isTextIcon ? customText : this.selectedIcon,
      color: this.selectedColor,
      iconType : iconType,
      iconColour: customTextColor
    });
  }


  onIconClick(icon: string): void {
    if (this.selectedIcon === icon) {
      this.selectedIcon = null; // Deselect if already selected
    } else {
      this.selectedIcon = icon;
      this.tabIndex = 1; // Optionally move to Colors tab
    }
    this.customIconForm.get('customText')?.setValue(null)
    this.customIconForm.get('iconType')?.setValue('')
    this.emitSelection();
  }

  private addSelectedColorIfMissing(): void {
    const color = this.selectedColor?.toLowerCase();
    if (color && !this.colors.map(c => c.toLowerCase()).includes(color)) {
      this.colors = [...this.colors, color];
    }
  }

  onColorClick(color: string) {
    const normalizedColor = color.trim().toLowerCase();
    const alreadyExists = this.colors.some(c => c.trim().toLowerCase() === normalizedColor);
    
    if (!alreadyExists) {
      this.colors = [...this.colors, color];
    }
    this.selectedColor = color;
    this.emitSelection();
  }

  onTextColorClick(textColor:string){
    this.customIconForm.get('customTextColor')?.setValue(textColor)
    this.emitSelection()
  }

  saveCustomIcon() {
    if (this.customIconForm.valid) {
      this.iconType = this.customIconForm.get('customText')?.value;
      this.iconColour = this.customIconForm.get('customTextColor')?.value;
      this.emitSelection();
    }
  }

  closeMenu(): void {
    this.trigger.closeMenu();
  }
}
